import type { TrackedTranslation } from '@ps/web-core-intl';
import { useTrackers } from '@ps/web-shared-analytics';
import { useTrackingLabel } from '@ps/web-shared-components';
import type { ValuesProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import styles from './StarsSquareIconButton.scss';
import ButtonText from './components/ButtonText/ButtonText';

export interface TranslationType extends Partial<ValuesProp> {
  tag: TrackedTranslation;
}
export interface Props {
  active?: boolean;
  className?: string;
  colorActiveIcon?: boolean;
  dataTestId?: string;
  disabled?: boolean;
  groupTextClassName?: string;
  Icon: React.FC;
  onClick: () => void;
  small?: boolean;
  subTitle?: React.ReactNode;
  translation: TranslationType;
}

const StarsSquareIconButton: React.FC<Props> = ({
  active,
  className,
  colorActiveIcon = true,
  dataTestId,
  disabled,
  groupTextClassName,
  Icon,
  onClick,
  small,
  subTitle,
  translation
}) => {
  const { buttonPressed } = useTrackers();
  const buttonName = useTrackingLabel(translation.tag);

  const handleClick = () => {
    buttonPressed({ buttonName });
    onClick();
  };

  return (
    <div
      className={classNames(styles.squareIconButton, className, {
        [styles.active]: active,
        [styles.small]: small,
        [styles.colorActiveIcon]: colorActiveIcon,
        [styles.disabled]: disabled
      })}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      <div className={classNames(styles.icon, { [styles.subTitle]: subTitle })}>
        <Icon />
      </div>
      {groupTextClassName ? (
        <div className={groupTextClassName}>
          <ButtonText translation={translation} subTitle={subTitle} />
        </div>
      ) : (
        <ButtonText translation={translation} subTitle={subTitle} />
      )}
    </div>
  );
};
export default StarsSquareIconButton;
